module.exports = __webpack_public_path__ + "static/media/pinnacle.b5d6a9b3.png";